import { TYPE_SHOW_NOTI } from "../../helper/const";
import { showToast } from "../../helper/helper";
import { getDataApi, postDataApi, putDataApi } from "../../seviecesApi";

const serviceMiddleware = (store) => (next) => async (action) => {
  const handleShowToast = (type, content) => {
    showToast(type, content);
  };

  if (action.meta) {
    const { method, url, querry, showToast } = action.meta;
    if (method === "GET") {
      const res = await getDataApi(url);
      action.payload = res;
    }
    if (method === "POST") {
      const res = await postDataApi(url, querry);
      action.payload = res;
    }
    if (method === "PUT") {
      const res = await putDataApi(url, querry);
      action.payload = res;
      if (showToast) {
        if (+res.status === 200) {
          handleShowToast(TYPE_SHOW_NOTI.success, res?.data?.message);
        } else {
          handleShowToast(TYPE_SHOW_NOTI.err, res?.data?.message);
        }
      }
    }
    next(action);
  }

  next(action);
};
export { serviceMiddleware };
